<template>
  <HomePrimary />
  <HomeNewsCarousel />
  <HomeService />
  <HomeDataCard />
  <LazyVisibleHomeBusiness hydrate-on-visible />
  <LazyVisibleHomeStrategy hydrate-on-visible />
  <LazyVisibleHomeQuality hydrate-on-visible />
  <!-- <LazyHomeDemo hydrate-on-visible /> -->
  <LazyVisibleHomeAboutBrand hydrate-on-visible />
  <LazyVisibleHomeCertification hydrate-on-visible />
  <LazyVisibleHomeSectors hydrate-on-visible />
  <LazyVisibleHomeHonor hydrate-on-visible />
  <LazyVisibleHomeNews hydrate-on-visible />
  <LazyVisibleHomePartner hydrate-on-visible />
  <LazyVisibleHomeQuestion hydrate-on-visible />
</template>

<script lang="ts" setup>
  const { t } = useI18n()

  useSeoMeta({
    title: () => t('page.index.primary.title'),
    description: () =>
      t('page.index.primary.desc', {
        expYear: new Date().getFullYear() - 1995,
      }),
  })
</script>
